const url = process.env.REACT_APP_API_URL + "/api/images/";

const secondBaseUrl = process.env.REACT_APP_ENERGY_DASHBOARD_API_URL + "/api";
export default {
  delete: (projectId: number | string, imageId: number | string) =>
    `${secondBaseUrl}/projects/${projectId}/images/${imageId}`,
  get: (projectId: number | string, imageId: number | string) =>
    `${secondBaseUrl}/projects/${projectId}/images/${imageId}`,
  list: (projectId: number | string) => `${secondBaseUrl}/projects/${projectId}/images`,
  post: url, // TODO: remove this after adding the new endpoint
};
